export default "assets/icon-play-bcbf639a.svg";